export default __webpack_public_path__ + "static/media/SocialifyMain.38628a77.svg";